// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'

export let DirectSessionMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_SESSION)
    this.Id = 0
    this.Name = ''
    this.ServerBeginDayDate = null
    this.Sessions = null
    this.CurrentSessionId = 0
    this.UseIntradayMarginCoef = false
    this.TimeZoneOffset = 0
    this.BlockTrading = false
    this.FirstDayOfWeek = 1;
}

DirectSessionMessage.prototype = Object.create(DirectMessageBase.prototype)